import { DEFAULT_FREE_TRIAL_DURATION_IN_DAYS } from '../billing/billing.interface';
import type { BillingSettings, CreateBillingSettings } from '../billing/billing.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class BillingSettingsFactory extends ObjectFactory<BillingSettings> {
  protected getDefaults(): BillingSettings {
    return { ...baseDocumentFactory.build(), freeTrialDurationInDays: DEFAULT_FREE_TRIAL_DURATION_IN_DAYS };
  }

  buildCreate(overrides: Partial<CreateBillingSettings> = {}): CreateBillingSettings {
    const { freeTrialDurationInDays } = this.build(overrides);
    return { freeTrialDurationInDays };
  }
}

export const billingSettingsFactory = new BillingSettingsFactory();
